// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roXLq2b1e1gvmtnoB2_5{flex-direction:column;flex-grow:1;height:100%;display:flex}.DE7eq4lduhopHKB__ITP{flex-grow:1;display:flex;position:relative}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `roXLq2b1e1gvmtnoB2_5`,
	"table": `DE7eq4lduhopHKB__ITP`
};
export default ___CSS_LOADER_EXPORT___;
